import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { AppConfig } from "../Utilities/app-config.service";
import { RecommendAgent } from "../models/recommend-agent";
import { HelperService } from "./helper.service";

@Injectable({
  providedIn: "root",
})
export class RecommendAgentService {
  constructor(private apiService: ApiService, private appConfig: AppConfig) {}

  getRecommendation() {
    return this.apiService.get(this.appConfig.GetUrl("getRecommendation"));
  }

  getRecommendationById(id: any) {
    return this.apiService.get(
      this.appConfig
        .GetUrl("getRecommendationById")
        .replace("[RECOMMENDID]", id)
    );
  }

  reviseRecommendation(recommendation) {
    return this.apiService.put(
      this.appConfig.GetUrl("reviseRecommendation"),
      recommendation
    );
  }

  askForRevise(id) {
    return this.apiService.post(
      this.appConfig.GetUrl("askForRevise").replace("[RECOMMENDID]", id)
    );
  }

  deleteRecommendation(id: number) {
    return this.apiService.delete(
      this.appConfig.GetUrl("deleteRecommendation").replace("[RECOMMENDID]", id)
    );
  }

  getHowDoYouKnowList() {
    return this.apiService.get(this.appConfig.GetUrl("getHowDoYouKnow"));
  }

  sendRecommendation(recommendation: RecommendAgent) {
    return this.apiService.post(
      this.appConfig.GetUrl("createRecommendation"),
      recommendation
    );
  }

  acceptRejectRecommendation(id: number, IsAccept: boolean) {
    return this.apiService.put(
      this.appConfig
        .GetUrl("acceptRecomendation")
        .replace("[RECOMMENDID]", id)
        .replace("[isAccept]", IsAccept)
    );
  }

  changeRecommendationVisibility(id, IsVisible: boolean) {
    return this.apiService.put(
      this.appConfig
        .GetUrl("changeRecommendationVisibility")
        .replace("[RECOMMENDID]", id)
        .replace("[IsVisible]", IsVisible)
    );
  }
}
